import React , {useEffect, useState} from "react";
import Layout from '../../../Layout/Lighttheme';
import Function from '../../../Fuction/Function';
import {Blog1} from '../../../../components/Blog';
// import Levelup from "../../../Level";
import { BrandList } from "../../../Brand";
import { SliderCol3 } from "../../../Slider";
import {getListBanner} from "../../../../service/campaignService";
import { Hotdeal1 } from "../../../Hotdeal";
import { Productgift1 } from "../../../ProductGift";
// import TodaySuggest from "../../../ProductSuggest/Todaysuggest";
import { Productcategory } from "../../../ProductList";
import SliderV1 from "../../../Slider/SliderTop/SliderV1";
import Img from '../../../Images';

const Home =({serverData})=>{
    const [bannerItems, setBannerItems] = useState([]);
    const loadBannerTop=()=>{
        try {
            getListBanner('B004T01').then((response)=>{
                if(response.status === 200 && response['message'] !== 'Không tìm thấy dữ liệu.'){
                    setBannerItems(response['message']);
                }
            })
        } catch(err) {
          console.error(err);
        }  
    }
    const [bannerNH, setBannerNH] = useState([]);
    const loadBannerNH=()=>{
        try {
            getListBanner('B005TMid01').then((response)=>{
                if(response.status === 200 && response['message'] !== 'Không tìm thấy dữ liệu.'){
                    setBannerNH(response['message']);
                }
            })
        } catch(err) {
          console.error(err);
        }  
    }

    const [bannerPopup, setBannerPopup] = useState([]);
    const loadBannerPopup=()=>{
        try {
            getListBanner('W015T01').then((response)=>{
                if(response.status === 200 && response['message'] !== 'Không tìm thấy dữ liệu.'){
                    setBannerPopup(response['message']);
                }
            })
        } catch(err) {
          console.error(err);
        }  
    }

    const [bannerBR, setBannerBR] = useState([]);
    const loadBannerBR=()=>{
        try {
            getListBanner('B006TMid01').then((response)=>{
                if(response.status === 200 && response['message'] !== 'Không tìm thấy dữ liệu.'){
                    setBannerBR(response['message']);
                }
            })
        } catch(err) {
          console.error(err);
        }  
    }
    const [showBanner, setShowBanner] = useState(true);
    useEffect(()=>{
       
        loadBannerTop();
        loadBannerNH();
        loadBannerBR();
        setShowBanner(true);
        loadBannerPopup()
        loadBannerPopup1();
            var _pageViewShowPopup = sessionStorage.getItem("pageViewShowPopup");
            if (_pageViewShowPopup === undefined) {
                sessionStorage.setItem("pageViewShowPopup", 0);
            }
             if (_pageViewShowPopup !== undefined && +_pageViewShowPopup !== 1) {
            setTimeout(function() {
                    setShowPopupDownloadApp(true);
                    // document.querySelector('.modal-open').style.overflow = 'hidden';
                    sessionStorage.setItem("pageViewShowPopup", 1);
                }, 9000);
            }
    },[])
    
    const handleCloseBanner=()=>{
        setShowBanner(false);
    }
    const [showPopupDownloadApp, setShowPopupDownloadApp] = useState(false);
      const [bannerPopup1, setBannerPopup1] = useState([]);
        const loadBannerPopup1=()=>{
            try {
                getListBanner('W016C01').then((response)=>{
                    if(response.status === 200 && response['message'] !== 'Không tìm thấy dữ liệu.'){
                        setBannerPopup1(response['message']);
                    }
                })
            } catch(err) {
              console.error(err);
            }  
        }
        const handleClosepopup=()=>{
        setShowPopupDownloadApp(false);
        //  document.querySelector('.modal-open').style.overflow = 'unset';
        sessionStorage.setItem("pageViewShowPopup", 1);
    }
    const handleOpentRedirect=(uri)=>{
            //  document.querySelector('.modal-open').style.overflow = 'unset'
            sessionStorage.setItem("pageViewShowPopup", 1);
            window.location.href = uri;
        }

    return(
        <Layout>
            <div>
                <div className="banner mt-3">
                    <div className="banner--content m-auto">
                        <div className="row row--maint m-0 ">
                            <div className="col-12 p-0 ">
                                <div className="row m-0 slider--top">
                                    <div className="col-9 ps-0">
                                        <div className="row-gap-2 banner--content--left h-100 w-100 position-relative">
                                            <SliderV1 serverData = { serverData.DataSliderPC?.message }/>
                                        </div>
                                    </div>
                                    <div className="col-3 ps-0 pe-0">
                                        <div className="row m-0 row-gap-2 h-100">
                                            {
                                                bannerItems.length > 0 ?(
                                                    bannerItems.map((item,i)=>{
                                                        return <div key={i} className="col-12 p-0 " >
                                                        <div className="banner--content--right h-100 position-relative overflow-hidden">
                                                            {/* <a href=""><img className="h-100 w-100" src="/static/image/banner_right.png" alt=""/></a> */}
                                                            <a href={item.link}><Img imgTitle={item.name} url={item.images} className="h-100 w-100" style=""/></a>
                                                            <div class="banner--content--right--button row m-0 w-100 position-absolute ">
                                                                <div class="col-5 p-0 my-auto h-100">
                                                                    <a href={item.link}>
                                                                        <div class="button py-2">
                                                                            <div class="text-center">MUA NGAY</div>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                                <div class="col-7 p-0"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    })
                                                ):(null)
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Function/>
                        </div>
                    </div>
                </div>
            </div>
           
            <Hotdeal1/>

            <Productgift1/>

            <SliderCol3 item={bannerNH} title='Ưu đãi ngành hàng'/>
            
            <SliderCol3 item={bannerBR} title='Chuyên trang thương hiệu'/>
            
            {/* <TodaySuggest/> */}

            <Productcategory/>
            
            {/* <Levelup/> */}

            <BrandList/>

            <Blog1/>
             {
               bannerPopup.length>0 && showBanner ? (
                    <div className="banner-show">
                    <div className="position-relative">
                        <div className="close-banner align-items-center pointer" onClick={handleCloseBanner}><span>x</span></div>
                        <div className="img-banner"><a href={bannerPopup[0].link}><img src={bannerPopup[0].images} alt={bannerPopup[0].name} /></a></div>
                    </div>
                    </div>
                ):(null)
             } 

        {bannerPopup1.length > 0 && showPopupDownloadApp === true ? (
        <div id="modal-msg">
          <div className="modal">
              <div className="modal-content-popup">
                  <div className="modal-body p-0 ">
                      <div className="position-relative">
                      <img onClick={()=>handleOpentRedirect(bannerPopup1[0]?.link)} src={bannerPopup1[0]?.images} alt="icon-popup" className="pointer"/>
                      <div className="position-absolute close-button">
                        <span onClick={handleClosepopup}><i className="bi bi-x-circle"></i></span>
                      </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
           ):(null)}                              
        </Layout>
    )
}

export default Home;